import './App.css';
import './tailwind.generated.css';
import React, {useEffect} from "react";
import {createLoginSession, logOutSession, USER_ROLE} from "./requests/AppSession";
import {useNavigate} from "react-router-dom";
import {useAuth} from "@workos-inc/authkit-react";
import {findUserLoginSession} from "./virtualtips/requests/AppRequestAuth";
import {baseWebUrl} from "./requests/NetworkRequestAuth0";

function App() {

    let navigate = useNavigate();

    const [roles, setRoles] = React.useState([]);

    const {isLoading, user, getAccessToken, signOut} = useAuth();

    const submitSuccess = async responseJson => {
        if (
            responseJson &&
            responseJson.userType
        ) {
            await createLoginSession(
                responseJson.userId,
                responseJson.username,
                user.email,
                user.emailVerified,
                responseJson.roles,
                responseJson.customerCode,
                responseJson.venueId,
                responseJson.dancerId,
                responseJson.privateDancePayFeatureFlag,
                responseJson.dancePayFeatureFlag,
                responseJson.drinkPayFeatureFlag,
                responseJson.stageTipFeatureFlag,
                responseJson.venueRewardsFeatureFlag,
                responseJson.venueStripePaymentsFeatureFlag,
                responseJson.venueInputCustomerCodePaymentsFeatureFlag,
                responseJson.venueScanCustomerCodePaymentsFeatureFlag
            );

            if (responseJson && responseJson.userType) {
                if (responseJson.roles) {
                    setRoles(responseJson.roles);
                }
            } else {
                navigate('/signup/mobile', {replace: true});
            }

        } else {
            navigate('/login/mobile', {replace: true});
        }
    };

    const submitError = forceLogout => {
        navigate('/login/mobile', {replace: true});
    };

    const logOutAndValidateEmail = () => {
        logOutSession().then(() => {
            signOut({returnTo: baseWebUrl + "/validateemail"})
        })
    };

    useEffect(() => {

        if (isLoading) {
            return;
        }

        if (user) {
            findUserLoginSession(submitSuccess, submitError, getAccessToken);
        } else {
            navigate('/login/mobile', {replace: true});
        }

        return function cleanup() {

        };
    }, [isLoading]);

    return (
        <>
            {

                (roles.includes(USER_ROLE) && user.emailVerified) ? navigate("/find", {replace: true}) :
                    roles.includes(USER_ROLE) ? logOutAndValidateEmail() :
                        <></>
            }
        </>
    );
}

export default App;
